import React from 'react';
import { get } from 'lodash-es';
import Button from 'reactstrap/lib/Button';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { Link } from 'site-modules/shared/components/link/link';
import { YmmsDropdowns } from 'site-modules/shared/components/ymms-dropdowns/ymms-dropdowns';
import { getUrlPathFromParams } from 'site-modules/shared/utils/core-breadcrumbs-builder';
import { CHANGE_VEHICLE_ID, URL_PATH } from 'site-modules/shared/constants/mpg';

import './different-vehicle-mpg.scss';

function getButton(vehicleData) {
  const styleId = get(vehicleData, 'style.id', '');

  return (
    <Button
      className="go-btn col-12 col-md-auto px-1 py-0_5 size-16 fw-medium"
      tag={Link}
      color="outline-primary-b"
      disabled={!styleId}
      to={styleId ? `${getUrlPathFromParams(vehicleData, URL_PATH)}?style=${styleId}` : '#'}
      data-tracking-id="mpg_different_submit"
    >
      Go
    </Button>
  );
}

export function DifferentVehicleMpg() {
  return (
    <Row id={CHANGE_VEHICLE_ID} className="different-vehicle-mpg">
      <h2 className="col-12 heading-4 mb-1_25">View cost to drive and MPG data for a different vehicle</h2>
      <Col xs={12} md={6}>
        <YmmsDropdowns
          dropdownClassName="ymms-dropdown form-control size-16 w-100 mb-1_5 px-0_75"
          dropdownLabels={{
            year: 'Select year',
            make: 'Select make',
            submodel: 'Select model',
            style: 'Select trim',
          }}
          dropdownTrackingIds={{
            year: 'mpg_different_year_select',
            make: 'mpg_different_make_select',
            submodel: 'mpg_different_model_select',
            style: 'mpg_different_trim_select',
          }}
        >
          {getButton}
        </YmmsDropdowns>
      </Col>
    </Row>
  );
}
